import { Exercise } from "./Exercises";
import { ExerciseService } from "app/shared/services/exercises.service";
import { SafeUrl } from "@angular/platform-browser/src/security/dom_sanitization_service";

export interface IProgram {
  _id: string;
  title: string;
  exerciseIds: string[];
}

export class Program implements IProgram {
  _id: string;
  title: string;
  exerciseIds: string[];

  exercises: Exercise[];
  previewUrl: SafeUrl | string;

  isRandom: boolean = false;

  contextID: string = "";

  static fromJson(data:IProgram): Program {
    let p = new Program
    p._id = data._id
    p.title = data.title ||""
    p.exerciseIds = data.exerciseIds || []

    return p
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/shared/models/Program.ts